<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div class="card">
        <div class="row">
          <div v-if="isRedirected" class="col-12 text-right">
            <button class="btn btn-link" @click="clearQueryParams">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div class="card-header border-0">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-8">
              <h3 class="mb-0">User Table</h3>
            </div>
            <div v-if="isAdmin" class="col-lg-6 col-4 text-right">
              <div class="btn-group" v-click-outside="hideDropdown">
                <base-button type="primary" size="sm" class="dropdown-toggle" @click="toggleDropdown">
                  <span class="btn-inner--icon text-white">
                    <i class="ni ni-fat-add"></i>
                  </span>
                  Add
                </base-button>
                <div class="dropdown-menu show" v-if="showDropdown" style="position: absolute; z-index: 1000;">
                  <a class="dropdown-item enabled-action" @click="navigateToOnboarding">Add User</a>
                  <a class="dropdown-item enabled-action" @click="addUserThroughCSV">Upload Users from CSV</a>
                </div>
                <base-button type="secondary" size="sm" class="ml-2" @click="exportToCSV">
                  <span class="btn-inner--icon text-white">
                    <i class="ni ni-cloud-download-95"></i>
                  </span>
                  Export
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="row flex-wrap mb-2 mb-md-0">
            <div class="col-12 col-md-2 mb-2 d-flex justify-content-start">
              <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="perPage" placeholder="Per page"
                @change="handlePerPageChange">
                <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-4 mt-lg-0 mb-2 d-flex justify-content-start">
              <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="tempFilterField" placeholder="Filter by"
                @change="handleTempFieldChange">
                <el-option class="select-primary" v-for="item in fieldOptions" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-4 d-flex justify-content-center">
              <base-input name="select" class="w-100 ml-2 mr-2">
                <el-select v-model="tempSearchQuery" filterable placeholder="Select value">
                  <el-option v-for="option in selectOptions" :key="option.label" :label="option.label"
                    :value="option.value">
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-12 col-md-2 d-flex justify-content-center justify-content-lg-start">
              <base-button class="ml-2 mt-0 mb-4 mr-2" size="md" type="primary"
                @click="handleSearchChange">Search</base-button>
            </div>
          </div>
          <el-table :data="queriedDataWithFullName" row-key="id" header-row-class-name="thead-light"
            @selection-change="selectionChange" @sort-change="handleSortChange">
            <el-table-column label="slNo" prop="slNo" min-width="100px">
            </el-table-column>
            <el-table-column label="userId" prop="userId" min-width="150px" sortable>
            </el-table-column>
            <el-table-column label="Name" min-width="260px" prop="firstName" sortable>
              <template v-slot:default="props">
                <div class="font-weight-bold">{{ props.row.fullName }}</div>
                <div class="text-xs">
                  ({{ props.row.nickName }})
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Broker" prop="brokerName" min-width="150px">
              <template v-slot:default="props">
                <span class="status text-capitalize"> {{ props.row.brokerName }}</span>
                <span v-if="props.row.feeder" class="badge badge-sm badge-primary ">
                  Feeder
                </span>
              </template>
            </el-table-column>
            <el-table-column label="status" prop="status" min-width="150px">
              <template v-slot:default="props">
                <div class="col-auto px-0">
                  <span class="badge badge-sm" :class="setStatusColor(props.row.status)">
                    {{ props.row.status }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="loginStatus" prop="loginStatus" min-width="150px">
            </el-table-column>
            <el-table-column label="action" min-width="200px">
              <template v-slot:default="props">
                <el-dropdown trigger="click" class="dropdown">
                  <span class="btn btn-sm btn-icon-only text-light">
                    <i class="fas fa-ellipsis-v mt-2"></i>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show">
                      <a class="dropdown-item" @click="impersonateUser(props.row.userId, props.row.fullName);"
                        href="#">View as <b>{{ props.row.firstName }}</b> </a>
                      <a v-if="isAdmin" class="dropdown-item enabled-action" @click="navigateToEdit(props.row.id)">
                        <i class="fas fa-edit mr-1 enabled-action"></i> Edit
                      </a>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-footer">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p v-if="isSuccess" class="card-category">
                Showing {{ from + 1 }} to {{ Math.min(to, total) }} of {{ total }} entries
              </p>
            </div>
            <base-pagination v-if="isSuccess" class="pagination-no-border" v-model="currentPage" :per-page="perPage"
              :total="total" :page-count="totalPages" @update:modelValue="handleFetchNextPage">
            </base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption,
  ElInput,
  ElDropdownMenu,
  ElDropdownItem,
  ElDropdown,
} from "element-plus";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BasePagination from "@/components/BasePagination";
import { emitter, saveDataToStorage } from './emitter';
import moment from "moment-timezone";
export default {
  components: {
    BasePagination,
    RouteBreadCrumb,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
    [ElDropdown.name]: ElDropdown,
    [ElDropdownItem.name]: ElDropdownItem,
    [ElDropdownMenu.name]: ElDropdownMenu,
  },
  computed: {
    pagedData() {
      return this.tableData;
    },
    queriedDataWithFullName() {
      const startIndex = this.from + 1;
      return this.pagedData.map((item, index) => ({
        ...item,
        fullName: `${item.firstName} ${item.lastName}`,
        slNo: startIndex + index,
      }));
    },
    from() {
      return (this.currentPage - 1) * this.perPage;
    },
    to() {
      return Math.min(this.from + this.perPage, this.total);
    },
  },
  data() {
    return {
      statusType: "success",
      perPage: 10,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      totalElements: 0,
      totalPages: 0,
      total: 0,
      searchQuery: '',
      tempSearchQuery: '',
      direction: "DESC",
      sortedColumn: "userId",
      propsToSearch: ["firstName", "lastName", "userId"],
      tableData: [],
      searchedData: [],
      isSuccess: false,
      tempFilterField: '',
      fieldOptions: ['Broker', 'Name', 'Status', 'User ID'],
      filterField: '',
      selectOptions: [],
      isRedirected: false,
      isAdmin: false,
      showDropdown: false,
    };
  },
  methods: {
    addUserThroughCSV() {
      this.$store.dispatch("userStore/getAllUsers", { root: true })
        .then(response => {
          const users = response.server.data;
          const toSnake = s => s.replace(/([A-Z])/g, "_$1").toLowerCase();
          const renameMap = { userProperties: "portfolio_status" };
          const exclude = ["id", "userVariables", "referenceDataBeans", "loginStatus", "brokerName", "createdTime", "updatedTime", "commonUrl", "port", "limitPercentage", "isLimitOrder", "version"];
          const sample = users[0];
          const baseKeys = Object.keys(sample).filter(k => !exclude.includes(k));
          const headers = baseKeys.map(k => renameMap[k] || toSnake(k));
          headers.push("portfolio_size", "common_url", "port", "limit_percentage", "is_limit_order", "version",
            "profit_percentage",
            "loss_percentage",
            "index_option_profit_percentage",
            "index_option_loss_percentage",
            "commodity_option_profit_percentage",
            "commodity_option_loss_percentage",
            "commodity_future_profit_percentage",
            "commodity_future_loss_percentage");
          const maxMult = Math.max(...users.map(u => (u.referenceDataBeans?.length || 0)));
          for (let i = 1; i <= maxMult; i++) {
            headers.push(`type${i}`, `multiplier${i}`);
          }
          headers.push("created_date", "last_updated_date");
          const rows = users.map((user) => {
            const portfolioSize = (user.userVariables || []).find(v => v.name === "PORTFOLIO_SIZE")?.value || '';
            const common_url = (user.userVariables || []).find(v => v.name === "COMMON_URL")?.value || '';
            const port = (user.userVariables || []).find(v => v.name === "PORT")?.value || '';
            const limitPercentage = (user.userVariables || []).find(v => v.name === "LIMIT_PERCENTAGE")?.value || '';
            const isLimitOrder = (user.userVariables || []).find(v => v.name === "IS_LIMIT_ORDER")?.value || '';
            const version = (user.userVariables || []).find(v => v.name === "VERSION")?.value || '';
            const profitPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("PROFIT_PERCENTAGE_LEVEL_"))
              .sort((a, b) => (parseInt(a.name?.split('_').pop()) || 0) - (parseInt(b.name?.split('_').pop()) || 0))
              .map(v => v.value?.trim() || '-')
              .join(" , ");
            const lossPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("LOSS_PERCENTAGE_LEVEL_"))
              .sort((a, b) => (parseInt(a.name?.split('_').pop()) || 0) - (parseInt(b.name?.split('_').pop()) || 0))
              .map(v => v.value?.trim() || '-')
              .join(" , ");
            const indexOptionProfitPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("IDX_OPT_PROFIT_PERCENTAGE_LEVEL_"))
              .sort((a, b) =>
                (parseInt(a.name?.split('_').pop()) || 0) -
                (parseInt(b.name?.split('_').pop()) || 0)
              )
              .map(v => v.value?.trim() || '-')
              .join(" , ");

            const indexOptionLossPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("IDX_OPT_LOSS_PERCENTAGE_LEVEL_"))
              .sort((a, b) =>
                (parseInt(a.name?.split('_').pop()) || 0) -
                (parseInt(b.name?.split('_').pop()) || 0)
              )
              .map(v => v.value?.trim() || '-')
              .join(" , ");

            const commodityOptionProfitPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("COM_OPT_PROFIT_PERCENTAGE_LEVEL_"))
              .sort((a, b) =>
                (parseInt(a.name?.split('_').pop()) || 0) -
                (parseInt(b.name?.split('_').pop()) || 0)
              )
              .map(v => v.value?.trim() || '-')
              .join(" , ");

            const commodityOptionLossPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("COM_OPT_LOSS_PERCENTAGE_LEVEL_"))
              .sort((a, b) =>
                (parseInt(a.name?.split('_').pop()) || 0) -
                (parseInt(b.name?.split('_').pop()) || 0)
              )
              .map(v => v.value?.trim() || '-')
              .join(" , ");

            const commodityFutureProfitPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("COM_FUT_PROFIT_PERCENTAGE_LEVEL_"))
              .sort((a, b) =>
                (parseInt(a.name?.split('_').pop()) || 0) -
                (parseInt(b.name?.split('_').pop()) || 0)
              )
              .map(v => v.value?.trim() || '-')
              .join(" , ");

            const commodityFutureLossPercentage = (user.userVariables || [])
              .filter(v => v.name?.startsWith("COM_FUT_LOSS_PERCENTAGE_LEVEL_"))
              .sort((a, b) =>
                (parseInt(a.name?.split('_').pop()) || 0) -
                (parseInt(b.name?.split('_').pop()) || 0)
              )
              .map(v => v.value?.trim() || '-')
              .join(" , ");
            const base = baseKeys.map(k =>
              k === "userProperties"
                ? JSON.stringify(user[k] || {})
                : user[k] ?? ''
            );
            const referenceList = user.referenceDataBeans || [];
            const dynamic = [];
            for (let i = 0; i < referenceList.length; i++) {
              dynamic.push(referenceList[i].key || '', referenceList[i].value || '');
            }
            const missing = maxMult - referenceList.length;
            for (let i = 0; i < missing; i++) {
              dynamic.push('', '');
            }
            return [
              ...base,
              portfolioSize,
              common_url,
              port,
              limitPercentage,
              isLimitOrder,
              version,
              profitPercentage,
              lossPercentage,
              indexOptionProfitPercentage,
              indexOptionLossPercentage,
              commodityOptionProfitPercentage,
              commodityOptionLossPercentage,
              commodityFutureProfitPercentage,
              commodityFutureLossPercentage,
              ...dynamic,
              this.formatTime(user.createdTime) || '',
              user.updatedTime ? this.formatTime(user.updatedTime) : ''
            ];
          });
          const csv = [headers, ...rows]
            .map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(","))
            .join("\n");
          sessionStorage.setItem("exportedCSV", csv);
          this.$router.push({ name: 'UploadUsers' });
        })
        .catch(error => {
          this.$router.push({ name: 'UploadUsers' });
          console.error("Failed to generate CSV:", error);
        });
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    hideDropdown() {
      this.showDropdown = false;
    },
    navigateToEdit(id) {
      sessionStorage.setItem('onboarding-id', id);
      this.$router.push({ name: 'Onboarding' });
    },
    navigateToOnboarding() {
      sessionStorage.removeItem('onboarding-id');
      this.$router.push({ name: 'Onboarding' });
    },
    setStatusColor(status) {
      return status === "ACTIVE" ? "badge-success" : "badge-warning";
    },
    setTable(pageNo, pageSize, sortBy, direction, filter, filterField) {
      let data = {
        pageNo: pageNo - 1,
        pageSize: pageSize,
        sortBy: sortBy,
        direction: direction,
        filter: filter,
        filterField: filterField,
      };
      this.$store.dispatch("userStore/getUserDetails", data, { root: true })
        .then(response => {
          this.tableData = response.server.data.userBean;
          this.totalElements = this.tableData.length;
          this.currentPage = response.server.data.currentPage + 1;
          this.totalPages = response.server.data.totalPages;
          this.total = response.server.data.totalElements;
          this.isSuccess = this.tableData.length > 0;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSortChange({ prop, order }) {
      console.log("order and prop", { prop, order })
      let sortProp = prop || 'userId';
      let sortOrder = order || 'ascending';
      this.setTable(this.currentPage, this.perPage, sortProp, this.mapSortOrder(sortOrder), this.searchQuery, this.filterField);
    },
    mapSortOrder(order) {
      const orderMap = {
        "ascending": "ASC",
        "descending": "DESC",
      };
      return orderMap[order];
    },
    handlePerPageChange(newPerPage) {
      this.perPage = newPerPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleFetchNextPage(newPage) {
      this.currentPage = newPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleSearchChange() {
      this.searchQuery = this.tempSearchQuery;
      this.setTable(1, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    impersonateUser(userId, name) {
      emitter.emit('data-sent', { userId: userId, name: name });
      saveDataToStorage(userId, name);
    },
    handleTempFieldChange() {
      this.tempSearchQuery = '';
      this.filterField = this.tempFilterField.replace(/ /g, '');
      let data = {
        type: ""
      };
      if (this.filterField == 'Name') {
        data.type = 'user-name'
      } else if (this.filterField == 'Broker') {
        data.type = 'broker-name'
      } else if (this.filterField == 'Status') {
        data.type = 'user-status'
      } else {
        data.type = 'user-id'
      }
      this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
        .then(response => {
          this.selectOptions = response.server.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearQueryParams() {
      this.$router.push({ path: '/statusDashboard' });
      this.isRedirected = false;
    },
    formatTime(timestamp) {
      return moment(timestamp).format('DD/MM/YYYY, hh:mm A');
    },
    exportToCSV() {
      this.$store.dispatch("userStore/getAllUsers", { root: true })
        .then(response => {
          const users = response.server.data;
          const toSnake = s => s.replace(/([A-Z])/g, "_$1").toLowerCase();
          const renameMap = { userProperties: "portfolio_status" };
          const exclude = ["id", "userVariables", "referenceDataBeans", "loginStatus", "brokerName", "createdTime", "updatedTime", "commonUrl", "port", "limitPercentage", "isLimitOrder", "version"];
          const sample = users[0];
          const baseKeys = Object.keys(sample).filter(k => !exclude.includes(k));
          const headers = baseKeys.map(k => renameMap[k] || toSnake(k));
          headers.push("portfolio_size", "common_url", "port", "limit_percentage", "is_limit_order", "version", "profit_percentage", "loss_percentage",
            "index_option_profit_percentage",
            "index_option_loss_percentage",
            "commodity_option_profit_percentage",
            "commodity_option_loss_percentage",
            "commodity_future_profit_percentage",
            "commodity_future_loss_percentage",);
          const maxMult = Math.max(...users.map(u => Object.keys(u.referenceDataBeans || {}).length));
          for (let i = 1; i <= maxMult; i++) headers.push(`type${i}`, `multiplier${i}`);
          headers.push("created_date", "last_updated_date");
          const sortedUsers = [...users].sort((a, b) => {
            const getSize = u => {
              return parseFloat((u.userVariables || []).find(v => v.name === "PORTFOLIO_SIZE")?.value) || 0;
            };
            return getSize(b) - getSize(a);
          });
          const rows = sortedUsers.map((user, i) => {
            try {
              const portfolioSize = (user.userVariables || []).find(v => v.name === "PORTFOLIO_SIZE")?.value || '';
              const common_url = (user.userVariables || []).find(v => v.name === "COMMON_URL")?.value || '';
              const port = (user.userVariables || []).find(v => v.name === "PORT")?.value || '';
              const limitPercentage = (user.userVariables || []).find(v => v.name === "LIMIT_PERCENTAGE")?.value || '';
              const isLimitOrder = (user.userVariables || []).find(v => v.name === "IS_LIMIT_ORDER")?.value || '';
              const version = (user.userVariables || []).find(v => v.name === "VERSION")?.value || '';
              const profitPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("PROFIT_PERCENTAGE_LEVEL_"))
                .sort((a, b) => (parseInt(a.name?.split('_').pop()) || 0) - (parseInt(b.name?.split('_').pop()) || 0))
                .map(v => v.value?.trim() || '-')
                .join(" , ");
              const lossPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("LOSS_PERCENTAGE_LEVEL_"))
                .sort((a, b) => (parseInt(a.name?.split('_').pop()) || 0) - (parseInt(b.name?.split('_').pop()) || 0))
                .map(v => v.value?.trim() || '-')
                .join(" , ");
              const indexOptionProfitPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("IDX_OPT_PROFIT_PERCENTAGE_LEVEL_"))
                .sort((a, b) =>
                  (parseInt(a.name?.split('_').pop()) || 0) -
                  (parseInt(b.name?.split('_').pop()) || 0)
                )
                .map(v => v.value?.trim() || '-')
                .join(" , ");

              const indexOptionLossPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("IDX_OPT_LOSS_PERCENTAGE_LEVEL_"))
                .sort((a, b) =>
                  (parseInt(a.name?.split('_').pop()) || 0) -
                  (parseInt(b.name?.split('_').pop()) || 0)
                )
                .map(v => v.value?.trim() || '-')
                .join(" , ");

              const commodityOptionProfitPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("COM_OPT_PROFIT_PERCENTAGE_LEVEL_"))
                .sort((a, b) =>
                  (parseInt(a.name?.split('_').pop()) || 0) -
                  (parseInt(b.name?.split('_').pop()) || 0)
                )
                .map(v => v.value?.trim() || '-')
                .join(" , ");

              const commodityOptionLossPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("COM_OPT_LOSS_PERCENTAGE_LEVEL_"))
                .sort((a, b) =>
                  (parseInt(a.name?.split('_').pop()) || 0) -
                  (parseInt(b.name?.split('_').pop()) || 0)
                )
                .map(v => v.value?.trim() || '-')
                .join(" , ");

              const commodityFutureProfitPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("COM_FUT_PROFIT_PERCENTAGE_LEVEL_"))
                .sort((a, b) =>
                  (parseInt(a.name?.split('_').pop()) || 0) -
                  (parseInt(b.name?.split('_').pop()) || 0)
                )
                .map(v => v.value?.trim() || '-')
                .join(" , ");

              const commodityFutureLossPercentage = (user.userVariables || [])
                .filter(v => v.name?.startsWith("COM_FUT_LOSS_PERCENTAGE_LEVEL_"))
                .sort((a, b) =>
                  (parseInt(a.name?.split('_').pop()) || 0) -
                  (parseInt(b.name?.split('_').pop()) || 0)
                )
                .map(v => v.value?.trim() || '-')
                .join(" , ");
              const base = baseKeys.map(k => k === "userProperties"
                ? JSON.stringify(user[k] || {})
                : this.formatCSVCell(user[k] ?? '', k)
              );
              const referenceList = user.referenceDataBeans || [];
              const dynamic = [];
              for (let i = 0; i < maxMult; i++) {
                const entry = referenceList[i] || {};
                dynamic.push(entry.key || '', entry.value || '');
              }
              return [
                ...base,
                portfolioSize,
                common_url,
                port,
                limitPercentage,
                isLimitOrder,
                version,
                profitPercentage,
                lossPercentage,
                indexOptionProfitPercentage,
                indexOptionLossPercentage,
                commodityOptionProfitPercentage,
                commodityOptionLossPercentage,
                commodityFutureProfitPercentage,
                commodityFutureLossPercentage,
                ...dynamic,
                this.formatTime(user.createdTime) || '',
                user.updatedTime ? this.formatTime(user.updatedTime) : ''
              ];
            } catch (e) {
              console.error(`Skipped user #${i + 1} due to error:`, e);
              return null;
            }
          }).filter(Boolean);
          const csv = [headers, ...rows].map(r =>
            r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")
          ).join("\n");
          const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `user_table_export_${this.getFormattedDateTime()}.csv`;
          link.click();
        })
        .catch(err => console.error("Export failed:", err));
    },
    getFormattedDateTime() {
      return moment().format("DD-MM-YYYY_HH-mm-ss");
    },
    formatCSVCell(value, key) {
      const pinKeys = ["pin"];
      if (pinKeys.includes(key) && typeof value === 'string' && /^\d{2,}$/.test(value)) {
        return `="${value}"`;
      }
      return value;
    }
  },
  mounted() {
    this.isAdmin = sessionStorage.getItem("isAdmin");
    this.tempFilterField = '';
    if (this.$route.query.status) {
      this.tempSearchQuery = this.$route.query.status;
      this.filterField = 'loginStatus';
      this.isRedirected = true;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.tempSearchQuery, this.filterField);
    } else {
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
